import React from 'react'
import { colors } from '../../../../styles/vars/colors.style'

const ExpeditionRoute1 = ({
  width = 341,
  height = 412,
  stroke = colors.dark,
  mask = colors.light,
  opacity = 1,
  pathLength = 578,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 341 412"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        opacity={opacity}
        stroke={stroke}
        strokeWidth={1}
        strokeDasharray="2 3"
        d="M246.361 405.106C318.371 333.105 343.262 260.454 340.139 224.563C335.794 174.627 314.069 144.231 240.204 122.519C166.338 100.808 138.096 92.1234 122.888 48.7007C111.832 17.1314 60.5848 -20.1758 0.871094 -38.1914"
      />
      <path
        opacity={opacity}
        stroke={mask}
        strokeWidth={2}
        ref={forwardRef.line}
        strokeDashoffset={0}
        strokeDasharray={pathLength}
        d="M246.361 405.106C318.371 333.105 343.262 260.454 340.139 224.563C335.794 174.627 314.069 144.231 240.204 122.519C166.338 100.808 138.096 92.1234 122.888 48.7007C111.832 17.1314 60.5848 -20.1758 0.871094 -38.1914"
      />
      <path
        opacity={0}
        ref={forwardRef.arrow}
        d="M243.8 407.943C243.576 407.996 243.378 407.785 243.444 407.564L245.273 401.482C245.34 401.261 245.621 401.195 245.779 401.363L250.132 405.988C250.29 406.156 250.207 406.433 249.982 406.486L243.8 407.943Z"
        fill={stroke}
      />
    </svg>
  )
}

export default ExpeditionRoute1
